import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';
import { setPersistence, browserSessionPersistence } from 'firebase/auth'; 
import { auth, loginUser, getUserProfile, resetUserPassword } from '../firebase'; 

const ClinicianLogin = ({onLogin, onSwitchToRegister, onBack}) => { 
  const [email, setEmail] = useState(''); 
  const [password, setPassword] = useState(''); 
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false); // YENİ: Beni hatırla state'i

  // YENİ: Sayfa yüklendiğinde hafızayı kontrol et (Beni Hatırla)
  useEffect(() => {
    const savedEmail = localStorage.getItem('rehber360_saved_email');
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);
const handleLogin = async () => { 
    setLoading(true); 
    try { 
      // 🛡️ ACIMASIZ GÜVENLİK: Kullanıcı ne seçerse seçsin, tarayıcı kapanırsa oturumu YOK ET!
      await setPersistence(auth, browserSessionPersistence);

      const userAuth = await loginUser(email, password); 
      const profile = await getUserProfile(userAuth.uid); 
      
      if (profile) { 
        // Beni hatırla sadece e-postayı tarayıcı metin hafızasına kaydeder (Oturumu değil)
        if (rememberMe) {
          localStorage.setItem('rehber360_saved_email', email);
        } else {
          localStorage.removeItem('rehber360_saved_email');
        }
        onLogin({ ...profile, uid: userAuth.uid });
      } else { 
        alert("Kullanıcı profili bulunamadı."); 
      } 
    } catch (e) { 
      alert("Giriş başarısız: " + e.message); 
    } finally { 
      setLoading(false); 
    } 
  };

  // YENİ: Şifremi Unuttum Motoru
  const handleForgotPassword = async () => {
    if (!email) {
      alert("Lütfen önce yukarıya e-posta adresinizi yazın, ardından 'Şifremi Unuttum' butonuna tıklayın.");
      return;
    }
    try {
      await resetUserPassword(email); 
      alert("Şifre sıfırlama bağlantısı e-posta adresinize gönderildi! (Spam klasörünü kontrol etmeyi unutmayın)");
    } catch (error) {
      alert("Bir hata oluştu veya bu e-posta kayıtlı değil: " + error.message);
    }
  };

  return (
    // GÜNCELLENDİ: Arka plan renk geçişi (Gradient) eklendi
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-4 no-print">
      
      {/* GÜNCELLENDİ: Buzlu cam görünümü (Glassmorphism) ve gölge eklendi */}
      <div className="w-full max-w-md bg-white/90 backdrop-blur-md p-10 rounded-3xl shadow-2xl border border-white/50">
        <button onClick={onBack} className="mb-6 flex items-center text-xs font-bold text-slate-500 hover:text-purple-600 transition-colors">← GERİ</button>
        <h2 className="text-3xl font-black text-center mb-8 text-slate-800">Uzman Girişi</h2>
        
        {/* Inputlara odaklanma (focus) renkleri eklendi */}
        <input type="email" value={email} onChange={e=>setEmail(e.target.value)} className="w-full px-4 py-3 bg-white rounded-xl border border-slate-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 outline-none transition-all mb-4" placeholder="E-posta"/>
        <input type="password" value={password} onChange={e=>setPassword(e.target.value)} className="w-full px-4 py-3 bg-white rounded-xl border border-slate-200 focus:border-purple-500 focus:ring-2 focus:ring-purple-200 outline-none transition-all mb-4" placeholder="Şifre"/>
        
        {/* YENİ: Beni Hatırla ve Şifremi Unuttum Satırı */}
        <div className="flex items-center justify-between mb-6">
          <label className="flex items-center space-x-2 cursor-pointer text-sm text-slate-600">
            <input 
              type="checkbox" 
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className="w-4 h-4 rounded border-slate-300 text-purple-600 focus:ring-purple-500"
            />
            <span>Beni Hatırla</span>
          </label>
          
          <button 
            onClick={handleForgotPassword}
            className="text-sm font-bold text-purple-600 hover:text-purple-800 transition-colors"
          >
            Şifremi Unuttum
          </button>
        </div>

        {/* Buton hover ve gölge efekti eklendi */}
        <button onClick={handleLogin} disabled={loading} className="w-full py-4 bg-purple-600 hover:bg-purple-700 transition-colors text-white rounded-xl font-bold flex justify-center items-center shadow-lg shadow-purple-200">
          {loading ? <Loader2 className="animate-spin h-5 w-5"/> : "Giriş Yap"}
        </button>
        
        <div className="mt-6 text-center text-sm text-slate-500">
          Hesabınız yok mu? <button onClick={onSwitchToRegister} className="text-purple-600 font-bold hover:underline">Kayıt Ol</button>
        </div>
      </div>
    </div>
  ); 
};

export default ClinicianLogin;